import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import efafcLogo from "../../assets/efafc.png";
import { User2, Mail } from 'lucide-react';

export default function TopBar() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleProfileClick = () => {
    if (currentUser) {
      navigate('/profile');
    } else {
      navigate('/auth');
    }
  };

  return (
    <div className="w-full flex items-center justify-between px-8 py-3 bg-transparent absolute top-0 left-0 z-[70] pointer-events-none">
      {/* Logo visible seulement sur desktop */}
      <Link to="/" className="pointer-events-auto hidden md:block">
        <img src={efafcLogo} alt="EFAFC Logo" className="h-20 drop-shadow-xl" />
      </Link>
      {/* Spacer pour mobile */}
      <div className="md:hidden"></div>
      
      {/* Boutons ronds fixés en haut à droite - masqués sur mobile */}
      <div className="fixed top-8 right-10 flex-row gap-4 z-[80] pointer-events-auto hidden md:flex">
        <button
          onClick={() => navigate('/contact')}
          className="w-12 h-12 rounded-xl bg-[#FFE400] flex items-center justify-center shadow-lg hover:bg-white transition text-[#001B56] text-2xl"
          aria-label="Contact"
        >
          <Mail size={28} />
        </button>
        <button
          onClick={handleProfileClick}
          className="w-12 h-12 rounded-xl bg-[#FFE400] flex items-center justify-center shadow-lg hover:bg-white transition text-[#001B56] text-2xl"
          aria-label={currentUser ? "Mon profil" : "Se connecter"}
        >
          <User2 size={28} />
        </button>
      </div>
    </div>
  );
} 